import { Col, Container, Row } from 'react-bootstrap'
import { getIntegrationDisplayName, IntegrationServiceId } from '../../../../../../common/integrations'
import { IntegrationIcon } from '../../../../../../components/IntegrationIcon'
import { ReactComponent as ZocksIcon } from '../../../../../../assets/ZocksIcon.svg'
import { ContactLinkingRows } from './ContactLinkingRows'
import { Path, useFormContext } from 'react-hook-form'
import { IntegrationSettings } from '../../schema'
import { useGetSchemaErrors } from '../../schemaErrors'
import { HouseholdCheckbox } from '../InboundMappingSettings/shared/HouseholdCheckbox'
import './ContactLinking.scss'

export interface ContactLinkingProps {
  serviceId: IntegrationServiceId
  zocksObjectName: string
  mappingPath: string
  isDisabled?: boolean
  onChange?: () => void
  showHouseholdCheckbox?: boolean
  allowClearing?: boolean
}

export const ContactLinking: React.FC<ContactLinkingProps> = ({
  serviceId,
  zocksObjectName,
  mappingPath,
  isDisabled = false,
  onChange,
  showHouseholdCheckbox = true,
  allowClearing = false,
}) => {
  const { watch } = useFormContext<IntegrationSettings>()
  const { getErrorOnPath } = useGetSchemaErrors()

  const contactObject = watch(`mappings.contact.objectName` as const)

  const contactLinksPath = `${mappingPath}.contactLinks` as Path<IntegrationSettings>

  const linkingError = getErrorOnPath(contactLinksPath)

  return (
    <Container className='p-0'>
      <Row className='mb-3'>
        <Col>
          <h4>Contact Linking</h4>
          <p className='zocks-text-gray-600'>
            Link {zocksObjectName} to {getIntegrationDisplayName(serviceId)} {contactObject}.
          </p>
        </Col>
      </Row>
      <div className='contact-link-grid mb-2 fw-bold'>
        <div className='d-flex align-items-center'>
          <ZocksIcon width='1rem' height='1rem' />
          <span className='ms-2'>ZOCKS FIELD</span>
        </div>
        <div className='contact-link-grid__target d-flex align-items-center'>
          <IntegrationIcon serviceId={serviceId} width='1rem' height='1rem' fill='black' />
          <span className='ms-2'>{getIntegrationDisplayName(serviceId).toUpperCase()}</span>
        </div>
      </div>
      <ContactLinkingRows serviceId={serviceId} mappingPath={mappingPath} isDisabled={isDisabled} onChange={onChange} allowClearing={allowClearing} />
      {linkingError && <div className='invalid-feedback d-block'>{linkingError || 'Incomplete contact linking information'}</div>}
      {showHouseholdCheckbox && <HouseholdCheckbox mappingPath={mappingPath} isDisabled={isDisabled} onChange={onChange} />}
    </Container>
  )
}
